import axios, { AxiosInstance } from 'axios';
import { baseApiUrl } from '../constants';


const service: AxiosInstance = axios.create({ baseURL: baseApiUrl });

service.interceptors.request.use(
    (config) => {
        const language = localStorage.i18nextLng;

        config.headers['Accept-Language'] = language ? language.slice(0, 2) : 'ru';

        config.headers['Content-Type'] = 'application/json';
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

service.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        const errorMessage = error.response?.data?.message || error.response?.data?.error || error.response?.data || error.response || error
        return Promise.reject(errorMessage);
    }
);

export default service;
